import React from 'react';
import { useSettings } from '../contexts/SettingsContext';
import ChatCard from './ChatCard';
import { canUseCompanyFeature } from '../utils/companyFeatureAccess';

const JDOverview = ({
  jdText,
  requirements = {},
  onPostJD = null,
  onStartTalentSourcing = null,
  showSourcingStrategy = true,
  showActionButtons = true,
  featureAccess = null,
}) => {
  const { settings } = useSettings();
  const primaryColor = settings.theme?.colors?.primary || '#3B5BDB';
  const canUseFeature = (feature) => canUseCompanyFeature(featureAccess, feature);
  const showPostAction = canUseFeature('job_posting') && onPostJD;
  const showSourcingAction = canUseFeature('sourcing') && onStartTalentSourcing;
  const showSourcingSection = showSourcingStrategy && canUseFeature('sourcing');

  return (
    <div className="chat_spacing_sm">
      {/* Title outside card */}
      <h4 className="chat_section_heading chat_mb_md">
        Job Description Draft
      </h4>

      <ChatCard variant="primary" size="lg" rounded="xl">
        <div className="chat_text_sm chat_text_primary whitespace-pre-wrap leading-relaxed">
          {jdText}
        </div>
      </ChatCard>

      {showSourcingSection && (
        <>
          <h4 className="chat_section_heading chat_mb_md chat_mt_md">
            Sourcing Strategy
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <ChatCard variant="secondary" size="md" rounded="xl">
              <div className="flex items-center gap-2 mb-1">
                <div className="w-5 h-5 rounded-md flex items-center justify-center bg-[#0A66C2]">
                  <span className="text-[9px] font-semibold text-white leading-none">in</span>
                </div>
                <h5 className="chat_heading_sm chat_font_semibold">LinkedIn</h5>
              </div>
              <p className="chat_text_sm chat_text_secondary">
                Professional network sourcing for role-fit profiles.
              </p>
            </ChatCard>

            <ChatCard variant="secondary" size="md" rounded="xl">
              <div className="flex items-center gap-2 mb-1">
                <div className="w-5 h-5 rounded-full flex items-center justify-center bg-white border border-gray-300">
                  <span
                    className="text-[10px] font-semibold"
                    style={{
                      background:
                        'conic-gradient(from 180deg at 50% 50%, #4285F4 0deg, #4285F4 90deg, #34A853 90deg, #34A853 180deg, #FBBC05 180deg, #FBBC05 270deg, #EA4335 270deg, #EA4335 360deg)',
                      WebkitBackgroundClip: 'text',
                      backgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                    }}
                  >
                    G
                  </span>
                </div>
                <h5 className="chat_heading_sm chat_font_semibold">Google</h5>
              </div>
              <p className="chat_text_sm chat_text_secondary">
                Broader web profile discovery and signal collection.
              </p>
            </ChatCard>
          </div>
        </>
      )}

      {showActionButtons && (showPostAction || showSourcingAction) && (
        <div className="flex flex-col md:flex-row gap-3 chat_mt_md">
          {showPostAction && (
            <button
              type="button"
              onClick={() => onPostJD()}
              className="flex-1 px-4 py-2 rounded-xl chat_font_medium chat_transition"
              style={{
                backgroundColor: 'transparent',
                color: primaryColor,
                border: `1px solid ${primaryColor}`,
              }}
            >
              Post JD
            </button>
          )}
          {showSourcingAction && (
            <button
              type="button"
              onClick={() => onStartTalentSourcing()}
              className="flex-1 px-4 py-2 rounded-xl text-white chat_font_medium chat_transition"
              style={{ backgroundColor: primaryColor }}
            >
              Start Talent Sourcing
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default JDOverview;
